module.exports = __webpack_public_path__ + "static/media/thumbnail.31ee3e9a.jpg";